import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fc00da0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "modal-title" }, " Add parents ", -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Select a parent family:", -1))
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { computed, nextTick, onMounted, ref } from 'vue'
import { getOrCreateChildRelationshipAsync } from './ProfileManager'
import { Modal } from 'bootstrap'
import ViewFamilySelector from '@/manage/ViewFamilySelector.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileAddParentsModal',
  emits: [
  'added',
],
  setup(__props, { expose: __expose, emit }) {

const childIdRef = ref<string>()
const selectedFamilyId = ref<string>()
const inputFocusedRef = ref(false)
const busyRef = ref(false)
const modalRef = ref<HTMLElement>()
const selectorRef = ref<InstanceType<typeof ViewFamilySelector>>()

const canAddRef = computed(() => !!selectedFamilyId.value && !inputFocusedRef.value && !busyRef.value)



__expose({
  open,
})

onMounted(() => {
  modalRef.value!.addEventListener('shown.bs.modal', async () => {
    await nextTick()
    selectorRef.value?.focus()
  })
})

function open(childId: string) {
  if (modalRef.value) {
    childIdRef.value = childId
    selectedFamilyId.value = undefined
    Modal.getOrCreateInstance(modalRef.value).show()
  }
}

function setInputFocused(focused: boolean) {
  inputFocusedRef.value = focused
}

async function addParents() {
  if (!childIdRef.value || !selectedFamilyId.value)
    throw 'Missing child or family id'

  await getOrCreateChildRelationshipAsync(childIdRef.value, selectedFamilyId.value)
  emit('added')

  if (modalRef.value) {
    Modal.getOrCreateInstance(modalRef.value).hide()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "modalRef",
      ref: modalRef,
      class: "modal add-related-profile-modal",
      tabindex: "-1"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              disabled: busyRef.value,
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(ViewFamilySelector, {
              ref_key: "selectorRef",
              ref: selectorRef,
              modelValue: selectedFamilyId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFamilyId).value = $event)),
              placeholder: "Type a parent's name",
              "edit-empty": "",
              "recent-living-only": "",
              "can-edit": !busyRef.value,
              onInputFocusChanged: setInputFocused
            }, null, 8, ["modelValue", "can-edit"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary",
              disabled: !canAddRef.value,
              onClick: _withModifiers(addParents, ["prevent"])
            }, " Add parents ", 8, _hoisted_9),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-primary",
              disabled: busyRef.value,
              "data-bs-dismiss": "modal"
            }, " Cancel ", 8, _hoisted_10)
          ])
        ])
      ])
    ], 512),
    _hoisted_11
  ], 64))
}
}

})